import axios from 'axios'

const withPaymentType = (query, paymentType) => {
  const parameters = new URLSearchParams(query || '')
  if (paymentType) {
    parameters.set('paymentType', paymentType)
  }
  return parameters.toString()
}

export const fetchTransactions = (query, paymentType) => {
  let parameters = ''
  if (query || paymentType) parameters = withPaymentType(query, paymentType)

  return axios
    .get(`/authenticated/financial-transactions?${parameters}`)
    .then((resp) => resp.data)
}

export const fetchTransactionsExcel = (query, paymentType) => {
  let parameters = ''
  if (query || paymentType) parameters = withPaymentType(query, paymentType)

  return axios
    .get(`/authenticated/financial-transactions/excel?${parameters}`, {
      responseType: 'arraybuffer'
    })
    .then((resp) => resp.data)
}
